/* Teepee Joy homepage redesign (card #727). Interactions only; every word on the page is rendered by the sections. */
(function(){
  if (window.__tpjHome) return; window.__tpjHome = true;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }

  // Three prints hung over the bed. Geometry measured on the room renders (same camera for every theme):
  // ledge at 9.4%, headboard top at 42.6%, bed centred near 49.5%.
  function hang(box, items){
    var hs = [0.145, 0.195, 0.145], gap = 0.03;
    var ws = items.map(function(p, i){ return hs[i] * (p.ar || 1); });
    var total = ws[0] + ws[1] + ws[2] + 2 * gap, k = Math.min(1, 0.6 / total);
    hs = hs.map(function(h){ return h * k; }); ws = ws.map(function(w){ return w * k; });
    var x = 0.495 - (ws[0] + ws[1] + ws[2] + 2 * gap * k) / 2, cy = 0.275;
    box.innerHTML = '';
    items.forEach(function(p, i){
      var f = document.createElement('div'); f.className = 'th-frame';
      f.style.left = (x * 100) + '%'; f.style.top = ((cy - hs[i] / 2) * 100) + '%';
      f.style.width = (ws[i] * 100) + '%'; f.style.height = (hs[i] * 100) + '%';
      var im = new Image(); im.src = p.img; im.alt = p.name; im.decoding = 'async';
      f.appendChild(im); box.appendChild(f);
      x += ws[i] + gap * k;
    });
  }

  // ---------- Hero: pick-a-theme room ----------
  function initHero(sec){
    if (sec.__th) return; sec.__th = true;
    var dataEl = sec.querySelector('[data-th-hero-data]'); if (!dataEl) return;
    var D; try { D = JSON.parse(dataEl.textContent); } catch(e){ return; }
    var room = sec.querySelector('.th-room'), frames = room.querySelector('.th-frames'),
        cap = sec.querySelector('[data-th-caption]'), cta = sec.querySelector('[data-th-cta]'),
        mini = sec.querySelector('[data-th-mini]'), chips = sec.querySelectorAll('.th-chip'), current = null;
    function loadLayer(l){
      if (l.dataset.src){ if (l.dataset.srcset){ l.srcset = l.dataset.srcset; l.removeAttribute('data-srcset'); } l.src = l.dataset.src; l.removeAttribute('data-src'); }
    }
    function miniHTML(T){
      return T.items.map(function(p){
        return '<li><a href="' + esc(p.url) + '"><img src="' + esc(p.thumb) + '" alt="" width="56" height="56" loading="lazy"><span><span class="th-nm">' + esc(p.name) +
          '</span><br><span class="th-pr">' + esc(p.price) + '</span></span><span class="th-go" aria-hidden="true">&rarr;</span></a></li>';
      }).join('');
    }
    function pick(key, first){
      if (key === current || !D.themes[key]) return; current = key;
      var T = D.themes[key];
      room.querySelectorAll('.th-layer').forEach(function(l){ var on = l.dataset.key === key; if (on) loadLayer(l); l.classList.toggle('is-on', on); });
      chips.forEach(function(c){ var on = c.dataset.key === key; c.setAttribute('aria-checked', String(on)); c.tabIndex = on ? 0 : -1; });
      var swap = function(){ hang(frames, T.items); frames.classList.remove('is-out'); };
      if (reduce || first || !frames.children.length) swap(); else { frames.classList.add('is-out'); setTimeout(swap, 380); }
      if (!first){
        cap.textContent = T.caption;
        cta.textContent = D.cta.replace('{theme}', T.word); cta.href = T.url;
        mini.innerHTML = miniHTML(T);
      }
    }
    chips.forEach(function(c){
      c.addEventListener('click', function(){ pick(c.dataset.key); });
      c.addEventListener('pointerenter', function(){ var l = room.querySelector('.th-layer[data-key="' + c.dataset.key + '"]'); if (l) loadLayer(l); }, { once:true });
    });
    // Arrow keys move between the theme chips (radio group behaviour)
    sec.querySelector('.th-chips').addEventListener('keydown', function(e){
      if (['ArrowRight','ArrowLeft','ArrowDown','ArrowUp'].indexOf(e.key) < 0) return;
      var list = Array.prototype.slice.call(chips), i = list.indexOf(document.activeElement); if (i < 0) return;
      e.preventDefault(); var n = list[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : list.length - 1)) % list.length];
      n.focus(); pick(n.dataset.key);
    });
    pick(D.first, true);
  }

  // ---------- Gallery wall: tap a frame for a closer look ----------
  function initGallery(sec){
    if (sec.__th) return; sec.__th = true;
    var dlg = sec.querySelector('dialog'); if (!dlg) return;
    var opener = null, img = dlg.querySelector('img');
    sec.querySelectorAll('.th-gframe').forEach(function(b){
      b.addEventListener('click', function(){
        opener = b;
        img.src = b.dataset.room; img.alt = b.dataset.alt || '';
        dlg.querySelector('.th-pcard-name').textContent = b.dataset.name;
        dlg.querySelector('.th-pr').textContent = b.dataset.price;
        dlg.querySelector('[data-th-go1]').href = b.dataset.url;
        dlg.querySelector('[data-th-go2]').href = b.dataset.theme;
        if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      });
    });
    dlg.querySelector('.th-x').addEventListener('click', function(){ dlg.close(); });
    dlg.addEventListener('click', function(e){ if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('close', function(){ if (opener) opener.focus(); });
  }

  // ---------- Before / after slider ----------
  function initBA(sec){
    var ba = sec.querySelector('.th-ba'); if (!ba || ba.__th) return; ba.__th = true;
    var r = ba.querySelector('input');
    r.addEventListener('input', function(){ ba.style.setProperty('--pos', r.value + '%'); });
  }

  // ---------- Round 4: motion as you scroll (Niv 2026-09-26) ----------
  // Only elements that start below the screen are ever hidden, so nothing already in view flashes.
  // Reduced motion, the theme editor and browsers without IntersectionObserver keep the still page.
  var RV = '.th-sec-head, .th-size-top > div:first-child, .th-sets > div:first-child, .th-tiles > *, .th-scroller > *,' +
    ' .th-proof-item, .th-delivery, .th-real > *, .th-lee > *, .th-custom > *, .th-email, .th-size-rule, .th-size-link,' +
    ' .th-themes-all, .th-journal-cta, .th-wall-top > .th-hint, .th-wall-top > .th-pobbo-tag';
  var POP = '.th-proof-sloth, .th-size-sloth-wrap, .th-email-sloth';
  var motionOn = !reduce && 'IntersectionObserver' in window && !(window.Shopify && Shopify.designMode);
  var io = null, done = typeof WeakSet === 'function' ? new WeakSet() : null;

  function countUp(el){
    var txt = el.getAttribute('data-th-final') || el.textContent;
    var m = txt.match(/^(\D*?)(\d[\d,]*(?:\.\d+)?)(.*)$/); if (!m) return;
    el.setAttribute('data-th-final', txt);
    var target = parseFloat(m[2].replace(/,/g, '')), dec = (m[2].split('.')[1] || '').length, comma = m[2].indexOf(',') > -1;
    var fmt = function(v){
      var s = v.toFixed(dec);
      if (comma){ var parts = s.split('.'); parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); s = parts.join('.'); }
      return m[1] + s + m[3];
    };
    // A rating starts near its real value (4.91 counts up from 4.00), so a buyer never sees a low score on the way.
    var from = dec ? Math.floor(target) : 0;
    var t0 = null, dur = 1300;
    function step(t){
      if (t0 === null) t0 = t;
      var k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3);
      el.textContent = k < 1 ? fmt(from + (target - from) * e) : txt;
      if (k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function reveal(el, delay){
    if (el.__thIn) return; el.__thIn = true;
    el.style.setProperty('--th-d', delay + 'ms');
    el.classList.add('is-in');
    var fig = el.classList.contains('th-proof-item') && el.querySelector('.th-fig');
    if (fig) setTimeout(function(){ countUp(fig); }, delay + 150);
    // Hand the element back to its normal styles once it has arrived, so hover transitions work as usual.
    setTimeout(function(){
      if (el.classList.contains('th-drop')) return;
      el.classList.remove('th-rv', 'th-rv-pop', 'th-hang', 'is-in'); el.style.removeProperty('--th-d');
    }, delay + (el.classList.contains('th-hang') ? 1200 : 900));
  }

  function initMotion(){
    if (!motionOn) return;
    document.documentElement.classList.add('th-motion');
    if (!io) io = new IntersectionObserver(function(entries){
      var hits = entries.filter(function(e){ return e.isIntersecting; }).map(function(e){ return e.target; });
      hits.sort(function(a, b){ var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect(); return (ra.top - rb.top) || (ra.left - rb.left); });
      hits.forEach(function(el, i){ io.unobserve(el); reveal(el, Math.min(i, 6) * (el.classList.contains('th-hang') ? 110 : 80)); });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    var fold = window.innerHeight * 0.92;
    function below(el){ return el.getBoundingClientRect().top > fold; }
    function watch(el, cls){
      if (done){ if (done.has(el)) return; done.add(el); }
      if (el.closest('.th-open')) return;                // the opening room is never delayed
      if (!below(el)) return;                             // already on screen: left exactly as it is, figures included
      el.classList.add(cls); io.observe(el); pending.push(el);
    }
    // Safety net: if the observer is ever late (throttled tab, odd browser), anything scrolled onto the screen
    // is revealed anyway, so no content can stay invisible.
    var pending = [], sweeping = false;
    function sweep(){
      sweeping = false;
      var vh = window.innerHeight, n = 0;
      pending = pending.filter(function(el){
        if (el.__thIn) return false;
        if (el.getBoundingClientRect().top < vh * 0.95){ io.unobserve(el); reveal(el, Math.min(n++, 6) * 80); return false; }
        return true;
      });
      if (!pending.length) window.removeEventListener('scroll', onSweep);
    }
    function onSweep(){ if (!sweeping){ sweeping = true; setTimeout(sweep, 250); } }
    window.addEventListener('scroll', onSweep, { passive:true });
    document.querySelectorAll('.tpjh').forEach(function(sec){
      sec.querySelectorAll(RV).forEach(function(el){ watch(el, 'th-rv'); });
      sec.querySelectorAll(POP).forEach(function(el){ watch(el, 'th-rv-pop'); });
      sec.querySelectorAll('.th-gframe').forEach(function(el){ watch(el, 'th-hang'); });
      sec.querySelectorAll('.th-size-panel').forEach(function(el){ watch(el, 'th-drop'); });
    });
    initClimb();
    window.addEventListener('beforeprint', function(){ document.documentElement.classList.remove('th-motion'); });
  }

  // Pobbo climbs in along the gallery rail from the wall's right edge (never over the art or the words).
  function initClimb(){
    document.querySelectorAll('.th-wall').forEach(function(wall){
      var sloth = wall.querySelector('.th-rail-sloth'); if (!sloth || wall.__thClimb) return; wall.__thClimb = true;
      var ticking = false, live = false;
      function update(){
        ticking = false;
        var r = wall.getBoundingClientRect(), vh = window.innerHeight;
        var p = Math.max(0, Math.min(1, (vh - r.top) / (vh * 0.55)));
        sloth.style.setProperty('--th-climb', (1 - Math.pow(1 - p, 2)).toFixed(3));
      }
      function onScroll(){ if (!ticking){ ticking = true; requestAnimationFrame(update); } }
      new IntersectionObserver(function(es){
        var on = es[0].isIntersecting;
        if (on && !live){ window.addEventListener('scroll', onScroll, { passive:true }); live = true; update(); }
        else if (!on && live){ window.removeEventListener('scroll', onScroll); live = false; update(); }
      }, { rootMargin: '200px 0px 200px 0px' }).observe(wall);
      update();
    });
  }

  function init(){
    document.querySelectorAll('[data-th-hero]').forEach(initHero);
    document.querySelectorAll('[data-th-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-th-custom]').forEach(initBA);
    initMotion();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function(e){
    var t = e.target; if (t) t.querySelectorAll('[data-th-hero],[data-th-gallery],[data-th-custom]').forEach(function(s){ s.__th = false; });
    init();
  });
})();
